import React from 'react';
import img2 from '../assets/Components/Exterior/Elevation-08.jpg.jpeg';

const About = () => {
    return (
        <div id="about" className="architectural-bg" style={{ padding: 'var(--section-padding)' }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 mb-5 mb-lg-0">
                        <h2 className="section-head-main">
                            Architectural <br />
                            Excellence
                        </h2>
                        <div style={{ width: '40px', height: '2px', backgroundColor: 'var(--secondary-color)', marginBottom: '30px' }}></div>
                    </div>
                    <div className="col-lg-7">
                        <p className="lead" style={{ color: 'var(--text-primary)', fontWeight: '300', marginBottom: '40px', fontSize: 'clamp(1.1rem, 3vw, 1.4rem)' }}>
                            ALWASEEQ is a professionally running architectural model making and events promotion firm.
                        </p>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                            We engage in all sort of architectural activities including designing, consulting, development, and construction.
                            With our highly experienced engineers and state-of-the-art infrastructure, we transform visions into physical reality.
                        </p>
                    </div>
                </div>

                <div className="row mt-5 pt-5 align-items-center">
                    <div className="col-lg-6 d-flex justify-content-lg-end">
                        <div className="arch-card" style={{ height: '380px', width: '100%', maxWidth: '90%', overflow: 'hidden' }}>
                            <img src={img2} alt="Architectural vision" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                    <div className="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
                        <span className="section-index">OUR VISION</span>
                        <h3 className="h2 mb-4" style={{ fontWeight: '400', letterSpacing: '-1px' }}>We Draft Your Dream World</h3>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                            We approach our designs from different perspectives which enable us to innovate, make optimal use of the space by blending together two core necessities: creativity and modern technology.
                        </p>
                        <ul className="list-unstyled mt-4" style={{ color: 'var(--secondary-color)', fontWeight: '500' }}>
                            <li className="mb-2">— INNOVATIVE DESIGN</li>
                            <li className="mb-2">— SUSTAINABLE PLANNING</li>
                            <li className="mb-2">— PRECISION EXECUTION</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;

